module.exports = __webpack_public_path__ + "img/icon4.10600b32.png";